export const styles = theme => ({
  textField: {
    width: "100%"
  },
  selection: {
    margin: "0 10px"
  },
  columnHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  icons: {
    display: "flex",
    alignItems: "center"
  },
  fab: {
    margin: 5,
    background: "royalblue",
    color: "white",
    "&:hover": {
      background: "#8FCAFC"
    }
  }
});
